import { render } from "./ListarPedidos.vue?vue&type=template&id=131f76bb"
import script from "./ListarPedidos.vue?vue&type=script&lang=js"
export * from "./ListarPedidos.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__